import React from 'react';
import { Button, Form, Header, Segment, Input } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import {fetchFaculties, fetchStudyCycle} from '../../Lookups/util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class AddStudyProgram extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studyCycles:[],
            studyCycle:'',

            name: '',
            englishName: '',
            documentNumber: '',
            comment: '',
            faculties: [],
            facultyList: [],

            nameErr: false,
            documentNumberErr: false,
            facultyListErr: false,
            studyCycleErr: false

        };

        this.addStudyProgram = this.addStudyProgram.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties(), fetchStudyCycle()])
            .then(axios.spread((facultiesRes, studyCyclesRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                const studyCycles = studyCyclesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                this.setState({ faculties, studyCycles });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch faculties');
            });
    }


    addStudyProgram(name, englishName, documentNumber, comment, facultyList, studyCycle) {
        if ( !name || facultyList.length === 0 || !studyCycle) {
            toast('Niste unijeli sva obavezna polja!');
            // if (!documentNumber) { this.setState({ documentNumberErr: true }); } else { this.setState({ documentNumberErr: false }); }
            if (!name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (!studyCycle) { this.setState({ studyCycleErr: true }); } else { this.setState({ studyCycleErr: false }); }
            if (facultyList.length === 0) { this.setState({ facultyListErr: true }); } else { this.setState({ facultyListErr: false }); }
        } else {
            let newStudyProgram = {};
            const organizationalUnits = facultyList.map(el => ({ id: el, name: this.state.faculties.find(e => e.id === el).text }));

            let language = { twoLetterCode: 'en' };
            let translations = [{ name: englishName, language }];

            if (name) newStudyProgram = { ...newStudyProgram, name };
            if (englishName) newStudyProgram = { ...newStudyProgram, translations };
            if (documentNumber) newStudyProgram = { ...newStudyProgram, documentNumber };
            if (studyCycle) newStudyProgram = { ...newStudyProgram, studyCycles: [studyCycle] };
            if (comment) newStudyProgram = { ...newStudyProgram, comment };
            if (organizationalUnits) newStudyProgram = { ...newStudyProgram, organizationalUnits };

            axios.post('study-programs/save-basic', { ...newStudyProgram })
                .then(res => {
                    toast('Uspješno ste kreirali smjer (studijski program).');
                })
                .catch(err => {
                    toast('Došlo je do greške! Kreiranje smjera (studijskog programa) nije uspjelo.');
                });
            window.history.go(-1);
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Header as="h1">Kreiranje smjera (studijskog programa)</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            Forma za kreiranje smjera (studijskog programa)
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Form noValidate>
                            <Form.Field
                                control={Input}
                                required
                                label="Naziv smjera (studijskog programa)"
                                value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                name="name"
                                placeholder="Unesite naziv smjera (studijskog programa)"
                                error={this.state.nameErr}
                            />
                            <Form.Field
                                control={Input}
                                label="Naziv smjera (studijskog programa) na engleskom jeziku"
                                value={this.state.englishName}
                                onChange={(e) => this.setState({ englishName: e.target.value })}
                                name="englishName"
                                placeholder="Unesite naziv na engleskom jeziku"
                            />

                            <Form.Field
                                // required
                                control={Input}
                                label="Broj odluke"
                                value={this.state.documentNumber}
                                onChange={(e) => this.setState({ documentNumber: e.target.value })}
                                name="documentNumber"
                                placeholder="Unesite broj odluke"
                                // error={this.state.documentNumberErr}
                            />


                            <Form.Field required error={this.state.facultyListErr}>
                                <label>  Organizaciona jedinica</label>
                                <Form.Dropdown clearable
                                    multiple
                                    selection
                                    placeholder="Odaberite jednu ili više organizacionih jedinica"
                                    value={this.state.facultyList}
                                    onChange={this.handleInputChange}
                                    name="facultyList"
                                    options={this.state.faculties}
                                    search
                                    fluid
                                />
                            </Form.Field>

                            <Form.Field required error={this.state.studyCycleErr}>
                                <label> Ciklus studija</label>
                                <Form.Dropdown clearable
                                    selection
                                    placeholder="Odaberite ciklus studija"
                                    value={this.state.studyCycle}
                                    onChange={this.handleInputChange}
                                    name="studyCycle"
                                    options={this.state.studyCycles}
                                    search
                                    fluid
                                />
                            </Form.Field>


                            <Form.Field>
                                <label>  Napomena</label>
                                <Form.TextArea
                                    placeholder="Unesite napomenu..."
                                    rows={1}
                                    value={this.state.comment}
                                    onChange={(e) => this.setState({ comment: e.target.value })}
                                />
                            </Form.Field>
                            <Button floated="right" color="blue" basic="true" onClick={() => window.history.go(-1)}>Odustani</Button>

                            <Button
                                floated="right"
                                color="blue"
                                onClick={
                                    () => {
                                        this.addStudyProgram(
                                            this.state.name,
                                            this.state.englishName,
                                            this.state.documentNumber,
                                            this.state.comment,
                                            this.state.facultyList,
                                            this.state.studyCycle
                                        );
                                    }
                                }
                            >
                                Kreiraj smjer (studijski program)
                            </Button>
                        </Form>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/AddStudyProgram.js